<template>
  <div class="landing-usage">
    <div v-if="routers.length" class="landing-usage__line">
      <span class="landing-usage__label">{{ $t("satellites.landings.used_routers") }}:</span>
      <span v-for="(router, index) in routers" :key="router.id">
        <router-link :to="{ name: 'SatelliteRouters', query: { router: router.id } }" class="landing-usage__link">{{ router.name }}</router-link
        ><template v-if="index < routers.length - 1">, </template>
      </span>
    </div>
  </div>
</template>
<script>
// Which routers use a landing: used_by of the landings API, { routers: [{ id, name }] }.
export default {
  name: "LandingUsage",
  props: {
    usedBy: {
      type: Object,
      required: true,
    },
  },
  computed: {
    routers() {
      return this.usedBy.routers || [];
    },
  },
};
</script>
<style lang="scss" scoped>
.landing-usage {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  white-space: normal;
}

.landing-usage__label {
  margin-right: 4px;
  color: #9b9ba4;
}

.landing-usage__link {
  color: #317475;
  font-weight: 500;
}

body.dark .landing-usage__link {
  color: #479495;
}
</style>
